export function isRightClick(e: MouseEvent | React.MouseEvent):boolean {
    // e.button === 2 - means right click
    return e.button === 2 // return true if click is handled
}

export function isBulkSelection(e?: MouseEvent | React.MouseEvent):boolean {
    return isCtrlPressed(e) || isShiftPressed(e)
}

export function isCtrlPressed(e?: MouseEvent | React.MouseEvent):boolean {
    return e?.ctrlKey || e?.metaKey || false
}

export function isShiftPressed(e?: MouseEvent | React.MouseEvent):boolean {
    return e?.shiftKey || false
}